import React from 'react';
import {TabType} from '../../types';
import TrialSendingPopup from '../trialSendingPopup/TrialSendingPopup';
import UpgradeModal from '../modalContents/UpgradeModal';
import PackageSelectionModal from '../modalContents/PackageSelectionModal';
import PackageSuccessModal from '../modalContents/PackageSuccessModal';
import SendApprovalModal from '../modalContents/SendApprovalModal';
import {useTranslation} from 'react-i18next';
import useGlobalShow from '../../../../hooks/useGlobalShow';
import {TXHR} from '../../../../assets/constants/constansts.type';
interface SendingPopupModalsProps {
    currentTab: TabType;
    amount: number;
    messageContent: string;
    onTrialSend: (contacts: string[]) => void;
    onActualSend: () => void;
    sendingXHR: TXHR | null;
}

function SendingPopupModals({currentTab, amount, messageContent, onTrialSend, onActualSend, sendingXHR}: SendingPopupModalsProps) {
    const trialPopupShow = useGlobalShow('isOpenTrialPopup');
    const packageSelectionShow = useGlobalShow('isOpenPackageSelection');
    const packageSuccessShow = useGlobalShow('isOpenPackageSuccess');
    const sendApprovalShow = useGlobalShow('isOpenSendApproval');
    const upgradeModalShow = useGlobalShow('isOpenUpgradeModal');
    const {t} = useTranslation('mailing');
    
    return (
        <>
            {trialPopupShow.isOpen && (
                <TrialSendingPopup
                    show={trialPopupShow}
                    onSend={onTrialSend}
                    contactType={(currentTab === 'email' ? 'email' : 'phone') as 'email' | 'phone'}
                    title={t(`${currentTab}TrialTitle`)}
                />
            )}
            {!!upgradeModalShow.isOpen && (
                <UpgradeModal
                    show={upgradeModalShow}
                    currentTab={currentTab}
                />
            )}
            {packageSelectionShow.isOpen && (
                <PackageSelectionModal
                    show={packageSelectionShow}
                    currentTab={currentTab}
                />
            )}
            {packageSuccessShow.isOpen && (
                <PackageSuccessModal
                    show={packageSuccessShow}
                />
            )}
            {sendApprovalShow.isOpen && (
                <SendApprovalModal
                    show={sendApprovalShow}
                    amount={amount}
                    messageContent={messageContent}
                    onActualSend={onActualSend}
                    XHR={sendingXHR}
                />
            )}
        </>
    );
}

export default SendingPopupModals;
